import {getWebsiteId} from "./getWebsiteId";
import {isDevEnvironment} from "./isDevEnvironment";

const WEBSITE_URLS = {
  1: "https://app.forthwithlife.co.uk",
  2: "https://app.sportsbloodtests.co.uk",
  3: "https://app.biomarkertracking.com",
};

const WEBSITE_URLS_DEV = {
  1: "https://appdev.forthwithlife.co.uk",
  2: "https://appdev.sportsbloodtests.co.uk",
  3: "https://appdev.biomarkertracking.com",
};

const siteId = getWebsiteId();

export const getAppUrl = websiteId => {
  if (isDevEnvironment) {
    return WEBSITE_URLS_DEV[siteId] ?? window.location.origin;
  }

  if (websiteId) return WEBSITE_URLS[websiteId] ?? window.location.origin;
  return WEBSITE_URLS[siteId] ?? window.location.origin;
};
